export default "__VITE_ASSET__CyakCrJb__"